import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { Budget } from '../interfaces/accounting.interface';

export const BudgetService = {
    getBudgetsByInstitution: async (page: number = 0, size: number = 10) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.BUDGET.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}`);
        return response.data;
    },
    getBudgetComparison: async (year: number, month: number) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.BUDGET.COMPARISON(institutionId!)}?year=${year}&month=${month}`);
        return response.data;
    },
    createBudget: async (budget: Budget) => {
        const response = await axios.post(ENDPOINTS.BUDGET.BASE, budget);
        return response.data;
    },
    updateBudget: async (id: string, budget: Budget) => {
        const response = await axios.put(ENDPOINTS.BUDGET.UPDATE(id), budget);
        return response.data;
    },
    deleteBudget: async (id: string) => {
        await axios.delete(ENDPOINTS.BUDGET.DELETE(id));
    },
};
